export const rc = (sq) => {
  const r = Math.floor((sq - 1) / 5);
  return [r, ((sq - 1) % 5) * 2 + (r % 2 === 0 ? 1 : 0)];
};

export const THEMES = {
  bois: { light: "#E6CFA4", dark: "#7A4B2A", frame: "#3B2414", grain: 0.22, white: ["#FFF8EA", "#E9D9B8", "#BFA67C"], black: ["#5A4A40", "#1D1611", "#0B0806"], label: "Bois précieux" },
  nuit: { light: "#3A4556", dark: "#151C27", frame: "#232C3A", grain: 0.06, white: ["#FFFFFF", "#F4F6F8", "#C9CED6"], black: ["#FFD27A", "#F5A30A", "#B67200"], label: "Nuit BKMPLAY" },
  marbre: { light: "#F2EBDD", dark: "#1F4D3F", frame: "#14332A", grain: 0.12, white: ["#FFFFFF", "#F1ECE2", "#C8BFAE"], black: ["#4A4A4A", "#1A1A1A", "#050505"], label: "Marbre" },
};

const KEY = "bkm_dames_prefs";
export const loadPrefs = () => ({ theme: "bois", coords: true, ...(JSON.parse(localStorage.getItem(KEY) || "{}")) });
export const savePrefs = (p) => localStorage.setItem(KEY, JSON.stringify(p));

// Deterministic per-square variation so the wood grain differs from square to square.
export const hash = (n) => {
  const x = Math.sin(n * 12.9898) * 43758.5453;
  return x - Math.floor(x);
};
